"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = calculatePopoverPosition;

var _xtend = _interopRequireDefault(require("xtend"));

var _calculatePositionContext = _interopRequireDefault(require("./calculate-position-context"));

var _calculatePlacementAlignment = _interopRequireDefault(require("./calculate-placement-alignment"));

var _calculateBodyStyle = _interopRequireDefault(require("./calculate-body-style"));

var _calculatePointerStyle = _interopRequireDefault(require("./calculate-pointer-style"));

var _adjustStylesForAnchorVisibility = _interopRequireDefault(require("./adjust-styles-for-anchor-visibility"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Not currently designed to deal with
// - iframes
// - more than one level of sub-document scrolling
// - horizontal scrolling

/**
 * @typedef {Object} PopoverPositionData
 * @property {string} placement
 * @property {string} alignment
 * @property {Object} pointerPositioningStyle
 * @property {Object} bodyPositioningStyle
 */

/**
 * Calculate positioning for a popover. Returns PopoverPositionData.
 *
 * @param {Object} options
 * @param {'top' | 'bottom' | 'left' | 'right'} options.placement
 * @param {'top' | 'bottom' | 'left' | 'right' | 'center' } options.alignment
 * @param {Function} options.getAnchorElement - Returns anchor element.
 * @param {Function} options.getPopoverElement - Returns popover element.
 * @param {Function} [options.getContainingElement] - Returns containing element.
 * @param {number} [options.offsetFromAnchor=5]
 * @param {number} [options.offsetFromEdge]
 * @param {boolean} [options.containWithinViewport=false]
 * @param {Function} [options.getScrollableParentElement] - Returns scrollable parent element.
 * @param {boolean} [options.allowPlacementAxisChange=true]
 * @param {boolean} [options.hasPointer=true]
 * @param {number} [options.pointerBase=12]
 * @param {number} [options.pointerAltitude=6]
 * @param {string} [options.pointerColor='#fff']
 * @param {boolean} [options.hideWhenAnchorIsOffscreen=false]
 * @return {PopoverPositionData}
 */
function calculatePopoverPosition(options) {
  const defaultedOptions = (0, _xtend.default)(options);
  defaultedOptions.offsetFromAnchor = def(options.offsetFromAnchor, 5);
  defaultedOptions.containWithinViewport = def(options.containWithinViewport, false);
  defaultedOptions.allowPlacementAxisChange = def(options.allowPlacementAxisChange, true);
  defaultedOptions.hasPointer = def(options.hasPointer, true);
  defaultedOptions.pointerAltitude = def(options.pointerAltitude, 6);
  defaultedOptions.pointerBase = def(options.pointerBase, 12);
  defaultedOptions.pointerColor = def(options.pointerColor, '#fff');
  defaultedOptions.hideWhenAnchorIsOffscreen = def(options.hideWhenAnchorIsOffscreen, false);

  if (!defaultedOptions.hasPointer) {
    defaultedOptions.pointerAltitude = 0;
    defaultedOptions.pointerBase = 0;
  }

  const context = (0, _calculatePositionContext.default)(defaultedOptions);
  const {
    placement,
    alignment
  } = (0, _calculatePlacementAlignment.default)(defaultedOptions, context);
  const baseBodyStyle = (0, _calculateBodyStyle.default)(placement, alignment, defaultedOptions, context);
  const basePointerStyle = (0, _calculatePointerStyle.default)(placement, defaultedOptions, context);
  const {
    bodyStyle,
    pointerStyle
  } = (0, _adjustStylesForAnchorVisibility.default)(basePointerStyle, baseBodyStyle, placement, defaultedOptions, context);
  return {
    placement,
    alignment,
    pointerPositioningStyle: pointerStyle,
    bodyPositioningStyle: bodyStyle
  };
}

function def(a, b) {
  return a === undefined ? b : a;
}